import React from "react";
import { NavLink } from "react-router-dom";
import { MerchantSignOutIcon } from "./MerchantIcons";
import MerchantSidebarBanner from "./MerchantSidebarBanner";

export default function MerchantMobileDrawer({
  activeKey,
  bannerLinkPath,
  isDarkMode,
  isOpen,
  merchantAccountId,
  merchantAccountName,
  navItems,
  onClose,
  onLogout,
  onToggleDarkMode,
  drawerRef,
  onTouchStart,
  onTouchEnd,
}) {
  return (
    <React.Fragment>
      <button
        className={"merchant-mobile-drawer-overlay" + (isOpen ? " open" : "")}
        type="button"
        aria-label="Close merchant menu"
        onClick={onClose}
      />

      <aside
        className={"merchant-mobile-drawer" + (isOpen ? " open" : "")}
        ref={drawerRef}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        <div className="merchant-mobile-drawer-brand">
          <div className="merchant-logo-mark merchant-logo-mark-small">
            <img
              src={process.env.PUBLIC_URL + "/merchant-login-logo.webp"}
              alt="Uniweb"
            />
          </div>
          <div>
            <div className="merchant-brand-name">Uniweb Pte. Ltd.</div>
            <div className="merchant-brand-sub">Merchant Portal</div>
          </div>
        </div>

        <div className="merchant-mobile-drawer-account">
          <div className="merchant-account-label">Merchant Account</div>
          <div className="merchant-mobile-drawer-account-name">{merchantAccountName}</div>
          <div className="merchant-account-id">{merchantAccountId}</div>
        </div>

        <nav className="merchant-mobile-drawer-nav">
          {navItems.map(function renderNavItem(item) {
            const Icon = item.icon;

            return (
              <NavLink
                key={item.key}
                className={
                  "merchant-mobile-drawer-nav-item" +
                  (activeKey === item.key ? " active" : "")
                }
                to={item.path}
                onClick={onClose}
              >
                <Icon />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>

        <div className="merchant-mobile-drawer-banner">
          <MerchantSidebarBanner linkPath={bannerLinkPath} onClick={onClose} />
        </div>

        <div className="merchant-mobile-drawer-footer">
          <button
            className="merchant-mobile-drawer-toggle"
            type="button"
            onClick={onToggleDarkMode}
          >
            <span className={"merchant-toggle-switch" + (isDarkMode ? " on" : "")}>
              <span className="merchant-toggle-knob" />
            </span>
            <span>{isDarkMode ? "Light mode" : "Dark mode"}</span>
          </button>

          <button className="merchant-mobile-drawer-signout" type="button" onClick={onLogout}>
            <MerchantSignOutIcon />
            <span>Sign Out</span>
          </button>
        </div>
      </aside>
    </React.Fragment>
  );
}
